"use strict";

var _possibleConstructorReturn = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var class_validator_is_nullable_1 = require("class-validator-is-nullable");

var lot_1 = require("./lot");

var program_1 = require("./program");

var country_1 = require("./country");

var LandingPagePublicDTO = function LandingPagePublicDTO() {
  _classCallCheck(this, LandingPagePublicDTO);
};

exports.LandingPagePublicDTO = LandingPagePublicDTO;

var LandingPagePrivateDTO =
/*#__PURE__*/
function (_LandingPagePublicDTO) {
  _inherits(LandingPagePrivateDTO, _LandingPagePublicDTO);

  function LandingPagePrivateDTO() {
    _classCallCheck(this, LandingPagePrivateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(LandingPagePrivateDTO).apply(this, arguments));
  }

  return LandingPagePrivateDTO;
}(LandingPagePublicDTO);

exports.LandingPagePrivateDTO = LandingPagePrivateDTO;

var LandingPageCreationDTO = function LandingPageCreationDTO() {
  _classCallCheck(this, LandingPageCreationDTO);
};

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageCreationDTO.prototype, "search", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "title", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 255), class_validator_is_nullable_1.IsNullable(), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "subTitle", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.Length(0, 3000), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "header", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "imgLeft", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "imgRight", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageCreationDTO.prototype, "enabled", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "country", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LandingPageCreationDTO.prototype, "order", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LandingPageCreationDTO.prototype, "showInHomepage", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "region", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "department", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "city", void 0);

__decorate([class_validator_1.IsEnum(lot_1.FiscalTools), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "fiscalTool", void 0);

__decorate([class_validator_1.IsNumber({}, {
  each: true
}), class_validator_1.IsOptional(), __metadata("design:type", Array)], LandingPageCreationDTO.prototype, "roomsCount", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageCreationDTO.prototype, "minPrice", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageCreationDTO.prototype, "maxPrice", void 0);

__decorate([class_validator_1.IsEnum(lot_1.LotTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageCreationDTO.prototype, "minSurface", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageCreationDTO.prototype, "maxSurface", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "delivery", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageCreationDTO.prototype, "invest", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageCreationDTO.prototype, "monthlyComplementaryIncome", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageCreationDTO.prototype, "annualTaxSaving", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageCreationDTO.prototype, "monthlySaving", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LandingPageCreationDTO.prototype, "latitude", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LandingPageCreationDTO.prototype, "longitude", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageCreationDTO.prototype, "useRadius", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "seoFooterText", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "seoFooterLinks", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 3000), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "trackingCodeGA", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 3000), __metadata("design:type", String)], LandingPageCreationDTO.prototype, "trackingCodeFB", void 0);

exports.LandingPageCreationDTO = LandingPageCreationDTO;

var LandingPageUpdateDTO = function LandingPageUpdateDTO() {
  _classCallCheck(this, LandingPageUpdateDTO);
};

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageUpdateDTO.prototype, "search", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "title", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "subTitle", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 3000), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "header", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "imgLeft", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "imgRight", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageUpdateDTO.prototype, "enabled", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "country", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LandingPageUpdateDTO.prototype, "order", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageUpdateDTO.prototype, "showInHomepage", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "region", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "department", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 255), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "city", void 0);

__decorate([class_validator_1.IsEnum(lot_1.FiscalTools), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "fiscalTool", void 0);

__decorate([class_validator_1.IsNumber({}, {
  each: true
}), class_validator_1.IsOptional(), __metadata("design:type", Array)], LandingPageUpdateDTO.prototype, "roomsCount", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageUpdateDTO.prototype, "minPrice", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageUpdateDTO.prototype, "maxPrice", void 0);

__decorate([class_validator_1.IsEnum(lot_1.LotTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageUpdateDTO.prototype, "minSurface", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageUpdateDTO.prototype, "maxSurface", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "delivery", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageUpdateDTO.prototype, "invest", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageUpdateDTO.prototype, "monthlyComplementaryIncome", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageUpdateDTO.prototype, "annualTaxSaving", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), class_validator_1.Min(0), class_validator_1.Max(99999999999), __metadata("design:type", Number)], LandingPageUpdateDTO.prototype, "monthlySaving", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LandingPageUpdateDTO.prototype, "latitude", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LandingPageUpdateDTO.prototype, "longitude", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageUpdateDTO.prototype, "useRadius", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "seoFooterText", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "seoFooterLinks", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 3000), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "trackingCodeGA", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), class_validator_1.Length(0, 3000), __metadata("design:type", String)], LandingPageUpdateDTO.prototype, "trackingCodeFB", void 0);

exports.LandingPageUpdateDTO = LandingPageUpdateDTO;

var LandingPageFilterDTO = function LandingPageFilterDTO() {
  _classCallCheck(this, LandingPageFilterDTO);
};

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", Array)], LandingPageFilterDTO.prototype, "countries", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageFilterDTO.prototype, "withMinPrice", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageFilterDTO.prototype, "homePageOnly", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LandingPageFilterDTO.prototype, "enabledOnly", void 0);

exports.LandingPageFilterDTO = LandingPageFilterDTO;